// Mirror of the two store-type constants the Category page references:
//   - STORE_TYPES             (legacy frontend/src/constants/store.ts:67-74)
//   - STORE_SHORT_TYPE_NAMES  (legacy frontend/src/constants/store.ts:83-90)
// Duplicated locally because pantry-features cannot import from the main
// app's ~/constants tree. Keep in sync with the legacy file if a new
// store-type is added there.

export const STORE_TYPES = {
  WOO: 'woocommerce',
  COVA: 'cova',
  GREENLINE: 'greenline',
  SHOPIFY: 'shopify',
  FLOWHUB: 'flowhub',
  LIGHTSPEED: 'lightspeed',
} as const

export const STORE_SHORT_TYPE_NAMES: Record<string, string> = {
  [STORE_TYPES.WOO]: 'Woo',
  [STORE_TYPES.COVA]: 'Cova',
  [STORE_TYPES.GREENLINE]: 'Greenline',
  [STORE_TYPES.SHOPIFY]: 'Shopify',
  [STORE_TYPES.FLOWHUB]: 'Flowhub',
  [STORE_TYPES.LIGHTSPEED]: 'Lightspeed',
}
